// All image URLs sourced from khansayazidi.com (Wix CDN)
const IMAGES = {
  // Logo
  logo: 'https://static.wixstatic.com/media/90a441_093d510781434814a80def856934a0b9~mv2.jpg',
  logoBlur: 'https://static.wixstatic.com/media/6b8d8a_ec37a045e1db44e781a74cf2ea3a00b7~mv2.jpg',

  // Hero / Collections
  collectionOlea: 'https://static.wixstatic.com/media/6b8d8a_d28c5770a32e4b4f9c440bd0ef1009a7f000.jpg',
  collectionDeesse: 'https://static.wixstatic.com/media/6b8d8a_377f87c8d95d469cbbd55b4d5023eb78f000.jpg',

  // Robinetterie
  douches: 'https://static.wixstatic.com/media/90a441_d0e73b43107b4762a0a897e73e86feea~mv2.jpg',
  robinetsPoser: 'https://static.wixstatic.com/media/90a441_668b5bd1b2e44334a102cfc6e91eae16~mv2.jpg',
  robinetsMuraux: 'https://static.wixstatic.com/media/90a441_45c40b00be684c3a8227c689c7da78ec~mv2.jpg',

  // Vasques
  vasquesMarbre: 'https://static.wixstatic.com/media/90a441_8863e9e3751845a297a88533a439fca7~mv2.jpg',
  vasquesLaiton: 'https://static.wixstatic.com/media/90a441_0d58fb5056b04058826c49897036dea6~mv2.jpg',
  vasquesCeramique: 'https://static.wixstatic.com/media/6b8d8a_ec37a045e1db44e781a74cf2ea3a00b7~mv2.jpg',

  // Designer
  designer: 'https://static.wixstatic.com/media/6b8d8a_fb38ee645be94702bf980acca8ecb987~mv2.jpg',
};

export default IMAGES;
